<div class="container mx-auto mt-5 px-4">
  <h1 class="text-3xl font-semibold text-center mb-6">Evaluaciones</h1>

  <div class="flex justify-between items-center mb-4">
    <button (click)="volver()" class="block bg-blue-500 hover:bg-blue-600 text-white font-semibold px-4 py-2 rounded">Volver</button>
  </div>
  <app-table
    [data]="evaluaciones"
    [columns]="columns"
    [actions]="actions"
    searchPlaceholder="Buscar evaluaciones..."
  ></app-table>
</div>
